import React from 'react';

/**
 * LoadingState - Shows a pulsing green circle to indicate AI is initializing
 */
export default function LoadingState() {
  return (
    <div className="ai-state-container">
      {/* Background circle */}
      <div className="ai-circle-background">
        {/* Custom white loading circle */}
        {/* <div className="ai-loading-white-circle"></div> */}
      </div>
      
      {/* Loading indicator dots */}
      <div className="ai-loading-dots">
        <div className="ai-dot ai-dot-1"></div>
        <div className="ai-dot ai-dot-2"></div>
        <div className="ai-dot ai-dot-3"></div>
      </div>
    </div>
  );
}
